import {
    Box,
    Button,
    Container,
    createListCollection,
    Field,
    Flex,
    Grid,
    GridItem,
    Image,
    Input,
    InputGroup,
    Portal,
    Select,
    Text,
    useBreakpointValue,
} from "@chakra-ui/react";
import Head from "next/head";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

import { toaster } from "@/components/ui/toaster";
import { usePostFormMutation } from "@/hooks/microservicesApi";
import Footer from "@/sections/home/Footer";
import Header from "@/sections/home/Header";

const Vender = () => {
    const [nombre, setNombre] = useState("");
    const [apellidos, setApellidos] = useState("");
    const [telefono, setTelefono] = useState("");
    const [email, setEmail] = useState("");
    const [tipo, setTipo] = useState("");
    const [ubicacion, setUbicacion] = useState("");
    const [valor, setValor] = useState("");
    const [postForm] = usePostFormMutation();

    const propertyType = createListCollection({
        items: [
            { value: "Casa", label: "Casa" },
            { value: "Departamento", label: "Departamento" },
            { value: "Terreno", label: "Terreno" },
            { value: "Local comercial", label: "Local comercial" },
            { value: "Bodega", label: "Bodega" },
            { value: "Otro", label: "Otro" },
        ],
    });

    const router = useRouter();

    const [screenSize, getDimension] = useState({
        winWidth: typeof window === "undefined" ? 0 : window.innerWidth,
        winHeight: typeof window === "undefined" ? 0 : window.innerHeight,
    });

    const isGreaterThanMd = useBreakpointValue({ base: false, md: true });

    const setDimensions = () => {
        getDimension({
            winWidth: typeof window === "undefined" ? 0 : window.innerWidth,
            winHeight: typeof window === "undefined" ? 0 : window.innerHeight,
        });
    };

    useEffect(() => {
        window.addEventListener("resize", setDimensions);

        return () => {
            window.removeEventListener("resize", setDimensions);
        };
    }, [screenSize]);

    const handleSubmit = () => {
        const body = {
            id: "e73e94be-88ee-47fb-a783-d69ea063e450",
            body: {
                fields: [
                    {
                        name: "firstname",
                        value: nombre,
                    },
                    {
                        name: "lastname",
                        value: apellidos,
                    },
                    {
                        name: "email",
                        value: email,
                    },
                    {
                        name: "phone",
                        value: telefono,
                    },
                    {
                        name: "tipo_de_propiedad",
                        value: tipo,
                    },
                    {
                        name: "ubicacion",
                        value: ubicacion,
                    },
                    {
                        name: "valor_promedio_de_la_propiedad",
                        value: valor,
                    },
                ],
                context: {
                    ipAddress: "3.14.97.137",
                    pageUri: "www.grupoguia.mx/contacto",
                    pageName: "Grupo Guia | Vender",
                },
            },
        };
        postForm(body)
            .then((response) => {
                if (response.error) {
                    toaster.create({
                        title: "Ooops!",
                        description:
                            "Al parecer hubo un error al procesar el envio de los datos... intenta nuevamente.",
                        type: "error",
                        duration: 4000,
                        closable: true,
                    });
                } else {
                    toaster.create({
                        title: "¡Exito!",
                        description: "Los datos se enviaron exitosamente",
                        type: "success",
                        duration: 4000,
                        closable: true,
                    });
                    router.push("/desarrollos/thankyoupage-contacto-gracias");
                }
            })
            .catch(() => {
                toaster.create({
                    title: "Ooops!",
                    description:
                        "Al parecer hubo un error al procesar el envio de los datos... intenta nuevamente.",
                    type: "error",
                    duration: 4000,
                    closable: true,
                });
            });
    };

    return (
        <>
            <Head>
                <title>Vender | Grupo Guía</title>
                <link rel="canonical" href="https://grupoguia.mx/vender" />
                <link rel="alternate" href="https://grupoguia.mx/vender" hrefLang="es-mx" />
            </Head>
            <Header />
            <Container
                maxW="7xl"
                {...(screenSize.winWidth <= 768 && { paddingInline: "0" })}
                mx="auto"
            >
                <Box
                    {...(screenSize.winWidth <= 768 && { full: "full" })}
                    mb={isGreaterThanMd ? "14" : "8"}
                >
                    <Box w="full" mx="auto" maxW="3x1" paddingInline="0">
                        <Flex
                            w="100%"
                            h="75vh"
                            id="fondo"
                            backgroundImage="url(https://media.grupoguia.mx/assets/home-page/vender/banner.webp)"
                            backgroundSize="cover"
                            backgroundPosition="center center"
                            backgroundRepeat="no-repeat"
                            position="relative"
                            p="0"
                            bgColor="gray.100"
                            borderRadius="20px"
                        >
                            <Flex
                                direction="column"
                                w="100%"
                                position="absolute"
                                left="0"
                                right="0"
                                height="100%"
                                paddingBottom={16}
                                justifyContent="end"
                                alignItems="center"
                                color="white"
                                borderRadius="lg"
                                bg="#121212AB"
                                textAlign="center"
                            >
                                <Text fontWeight="400" fontSize={isGreaterThanMd ? "4xl" : "2xl"}>
                                    {" "}
                                    <strong>Vende tu propiedad</strong> de la forma más sencilla.
                                </Text>
                                <Text fontWeight={400} fontSize={isGreaterThanMd ? "3xl" : "xl"}>
                                    ¡Consulta con nuestros asesores!
                                </Text>
                            </Flex>
                        </Flex>
                    </Box>
                </Box>
                <Box my={20} color="black">
                    <Text fontSize="2xl" fontWeight={500} textAlign="center">
                        Deja tus datos y un asesor te contactará
                    </Text>
                    <form
                        style={{
                            width: "80%",
                            margin: "auto",
                            marginTop: "2rem",
                            marginBottom: "2rem",
                            textAlign: "-webkit-center",
                        }}
                        onSubmit={(e) => {
                            e.preventDefault();
                            handleSubmit();
                        }}
                    >
                        <Grid
                            templateColumns="repeat(2, 1fr)"
                            gap={4}
                            alignItems="center"
                            mt={2}
                            pt={6}
                            maxW="4xl"
                            margin="auto"
                            my={12}
                        >
                            <GridItem colSpan={1}>
                                <Field.Root mb={3}>
                                    <Input
                                        rounded="full"
                                        placeholder="Nombre(s)"
                                        marginBottom="10px"
                                        id="nombres"
                                        type="text"
                                        py={5}
                                        value={nombre}
                                        required
                                        onChange={(e) => {
                                            e.preventDefault();
                                            setNombre(e.target.value);
                                        }}
                                        onBlur={(e) => {
                                            e.preventDefault();
                                            setNombre(e.target.value);
                                        }}
                                        px={4}
                                    />
                                </Field.Root>
                            </GridItem>
                            <GridItem colSpan={1}>
                                <Field.Root mb={3}>
                                    <Input
                                        rounded="full"
                                        placeholder="Apellidos"
                                        marginBottom="10px"
                                        value={apellidos}
                                        id="apellidos"
                                        type="text"
                                        py={5}
                                        required
                                        onChange={(e) => {
                                            e.preventDefault();
                                            setApellidos(e.target.value);
                                        }}
                                        onBlur={(e) => {
                                            e.preventDefault();
                                            setApellidos(e.target.value);
                                        }}
                                        px={4}
                                    />
                                </Field.Root>
                            </GridItem>
                            <GridItem colSpan={1}>
                                <Field.Root mb={3}>
                                    <InputGroup
                                        marginBottom="20px"
                                        startAddon={
                                            <Flex px={2}>
                                                <Image
                                                    src="https://media.grupoguia.mx/assets/home-page/icons/mexico.svg"
                                                    width="4"
                                                    height="4"
                                                    alt="mexico"
                                                    ml={1}
                                                />
                                                <Text
                                                    fontSize="xs"
                                                    fontWeight={500}
                                                    mx="1"
                                                    color="gray.600"
                                                >
                                                    +52
                                                </Text>
                                            </Flex>
                                        }
                                        startAddonProps={{
                                            borderLeftRadius: "24px",
                                            backgroundColor: "#FFFFFF",
                                            borderColor: "gray.300",
                                            borderRightWidth: "0",
                                            borderWidth: "1px",
                                        }}
                                    >
                                        <Input
                                            borderRadius="24px"
                                            placeholder="Teléfono"
                                            type="number"
                                            id="telefono"
                                            py={5}
                                            px={4}
                                            value={telefono}
                                            required
                                            onChange={(e) => {
                                                e.preventDefault();
                                                setTelefono(e.target.value);
                                            }}
                                            onBlur={(e) => {
                                                e.preventDefault();
                                                setTelefono(e.target.value);
                                            }}
                                        />
                                    </InputGroup>
                                </Field.Root>
                            </GridItem>
                            <GridItem colSpan={1}>
                                <Field.Root mb={3}>
                                    <Input
                                        rounded="full"
                                        placeholder="Correo electrónico"
                                        marginBottom="10px"
                                        value={email}
                                        id="email"
                                        type="email"
                                        py={5}
                                        required
                                        onChange={(e) => {
                                            e.preventDefault();
                                            setEmail(e.target.value);
                                        }}
                                        onBlur={(e) => {
                                            e.preventDefault();
                                            setEmail(e.target.value);
                                        }}
                                        px={4}
                                    />
                                </Field.Root>
                            </GridItem>

                            <GridItem colSpan={2}>
                                <Field.Root mb={3} required>
                                    <Select.Root
                                        collection={propertyType}
                                        rounded="full"
                                        onValueChange={(details) => setTipo(details.value[0])}
                                    >
                                        <Select.HiddenSelect />
                                        <Select.Control>
                                            <Select.Trigger pl={4} rounded="full">
                                                <Select.ValueText
                                                    placeholder="Tipo de inmueble"
                                                    color="gray.600"
                                                />
                                            </Select.Trigger>
                                            <Select.IndicatorGroup pr={4}>
                                                <Select.Indicator />
                                            </Select.IndicatorGroup>
                                        </Select.Control>
                                        <Portal>
                                            <Select.Positioner>
                                                <Select.Content p={2}>
                                                    {propertyType.items.map((type) => (
                                                        <Select.Item
                                                            item={type}
                                                            key={type.value}
                                                            color="gray.600"
                                                            p={1}
                                                        >
                                                            {type.label}
                                                            <Select.ItemIndicator />
                                                        </Select.Item>
                                                    ))}
                                                </Select.Content>
                                            </Select.Positioner>
                                        </Portal>
                                    </Select.Root>
                                </Field.Root>
                            </GridItem>
                            <GridItem colSpan={2}>
                                <Field.Root mb={3}>
                                    <Input
                                        rounded="full"
                                        placeholder="Ubicación del inmueble"
                                        marginBottom="10px"
                                        value={ubicacion}
                                        id="ubicación"
                                        type="text"
                                        py={5}
                                        required
                                        onChange={(e) => {
                                            e.preventDefault();
                                            setUbicacion(e.target.value);
                                        }}
                                        onBlur={(e) => {
                                            e.preventDefault();
                                            setUbicacion(e.target.value);
                                        }}
                                        px={4}
                                    />
                                </Field.Root>
                            </GridItem>
                            <GridItem colSpan={2}>
                                <Field.Root mb={3}>
                                    <Input
                                        rounded="full"
                                        placeholder="Valor del inmueble"
                                        marginBottom="10px"
                                        value={valor}
                                        min={1}
                                        id="valor"
                                        type="number"
                                        py={5}
                                        required
                                        onChange={(e) => {
                                            e.preventDefault();
                                            setValor(e.target.value);
                                        }}
                                        onBlur={(e) => {
                                            e.preventDefault();
                                            setValor(e.target.value);
                                        }}
                                        px={4}
                                    />
                                </Field.Root>
                            </GridItem>
                        </Grid>
                        <Button
                            rounded="full"
                            w={isGreaterThanMd ? "50%" : "80%"}
                            margin="auto"
                            fontWeight="500"
                            color="black"
                            borderColor="#FFCD00"
                            _hover={{
                                bg: "brand.600",
                            }}
                            type="submit"
                            bg="brand.500"
                        >
                            Enviar
                        </Button>
                    </form>
                </Box>
                <Box>
                    <Footer esGuiaRent={false} />
                </Box>
            </Container>
        </>
    );
};

export default Vender;
